import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core'

import { LoggerService } from 'app/core/logger/logger.service'

import { BaseSvgComponent } from './base-svg.component'

/**
 * Standalone SvgComponent to display svg inline.
 *
 *  - Specify the url input to load an SVG icon from a URL.
 *   The SVG content is directly inlined as a child of the <pai-svg> component,
 *   so that CSS styles can easily be applied to it.
 *   The URL is loaded via fetch, so it must be on the same domain as the page or its
 *   server must be configured to allow cross-domain requests.
 * @example
 *   <pai-svg url="assets/arrow.svg"></pai-svg>
 */
@Component({
  selector: 'pai-svg',
  template: '',
  standalone: true,
  styles: `
    :host {
      display: flex;
    }
  `,
  host: {
    '[attr.data-url]': 'urlAndAttrs().url',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SvgComponent extends BaseSvgComponent {
  readonly url = input.required<string>()
  readonly attrs = input<Record<string, string>>()

  protected readonly logger = inject(LoggerService).getInstance('SvgComponent')

  protected readonly urlAndAttrs = computed(() => ({
    url: this.url(),
    attrs: this.attrs(),
  }))
}
